import { render, staticRenderFns } from "./myThesisProposal.vue?vue&type=template&id=72c97528&scoped=true"
import script from "./myThesisProposal.vue?vue&type=script&lang=js"
export * from "./myThesisProposal.vue?vue&type=script&lang=js"
import style0 from "./myThesisProposal.vue?vue&type=style&index=0&id=72c97528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c97528",
  null
  
)

export default component.exports